<template>
   <router-link to="/" exact class="custom-link d-flex align-center">
      <img src="@/assets/logo_demo.svg" alt="Logo" height="30px" v-if="isDemo">
      <img src="@/assets/landkreis-hof.png" alt="Logo" height="30px" v-else-if="client === 'Hof'">
      <img src="@/assets/logo-nopf.svg" alt="Logo" height="30px" v-else>
   </router-link>
</template>

<script>
export default {
   name: "app-layout-navbar-logo",
   computed: {
      isDemo: function () {
         return process.env.VUE_APP_DEMO;
      },
      client() {
        return process.env.VUE_APP_CLIENT;
      }
   },
  created() {
     if (this.client === 'Hof') {
       this.$vuetify.theme.themes.light.primary = '#1F5DA1'
       this.$vuetify.theme.themes.light.secondary = '#01A6AB'
     }
  }
}
</script>

<style scoped>

</style>
